<template>
  <div>
    <notifications group="foo" />
    <Breadcrumb></Breadcrumb>
    <div v-if="currentJewelSelection && !isSearching">
      <div class="col d-inline-flex px-0 mt-4 row" v-if="
        currentJewelSelection && !!currentJewelSelection.name && !isSearching
      ">
        <div class="col-12 col-md-6 text-left pl-md-0 order-2 order-md-1">
          <div class="row d-none d-md-block">
            <div class="col-md-7">
              <p class="w-100 jewel-name title-font pl-5">
                {{ currentJewelSelection.name }}
              </p>
              <p class="text-break w-100 jewel-description pl-5 mb-0"
                v-if="currentJewelSelection.productType === 'KIT'">
                {{ $t(`kit-contains`) }}
              </p>

              <p class="text-break w-100 jewel-description pl-5" style="white-space: pre-line"
                v-html="jewelDescription"></p>
            </div>
            <div class="pl-5 mb-3" v-if="currentJewelSelection.productType === 'KIT'">
              <div class="wrapper">
                <table class="table table-image mb-0">
                  <thead>
                    <tr>
                      <th class="align-middle bl-color">{{ $t(`model`) }}</th>
                      <th class="align-middle bl-color">
                        {{ $t(`quantity`) }}
                      </th>
                      <th class="align-middle bl-color">
                        {{ $t(`description`) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(
item, index
                        ) in currentJewelSelection.itemsInKit" :key="index">
                      <td class="align-middle d-inline-flex w-100" :style="{
                        'border-top': index === 0 ? 'none !important' : '',
                      }" style="border-top: none !important">
                        <div style="align-self: center">
                          <span>{{ item.name || item.label }}</span>
                        </div>
                        <img style="align-self: center" height="50" width="50" :src="baseImageUrl + item.image"
                          alt="" />
                      </td>
                      <td class="align-middle bl-color">
                        <span> {{ item.quantity }} </span>
                      </td>
                      <td class="align-middle bl-color">
                        <span> {{ item.description }} </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-7 p-0" style="z-index: 2">
              <product-settings ref="productSettings"></product-settings>
            </div>
            <div class="col-md-5 margin-top-auto">
              <div class="row">
                <div class="col-12">
                  <div class="price-info border-left-0">
                    <div class="w-100">
                      <p class="
                                text-left
                                mb-0
                                pl-md-2 pl-5
                                text-uppercase
                                label-menu
                              ">
                        {{ $t("quantity") }}
                      </p>
                    </div>
                    <div class="w-100 text-right">
                      <input type="number" class="text-center input-quantity" step="1" min="0" @change="changeQuantity"
                        v-model="quantity" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="price-info jewel-value">
                    <div class="w-100">
                      <div class="
                                text-left
                                pl-md-2 pl-5
                                text-uppercase
                                label-menu
                                avg-price-label
                              ">
                        {{ $t("jewelValue") }}
                      </div>
                      <div class="average-price text-left pl-md-2 pl-5" v-if="
                        isGioielleriaItalianaB2B &&
                        retailPerc === 1 &&
                        currentJewelSelection.productType !== 'KIT' &&
                        getPriceValue() < getAverageOrVatPrice()
                      ">
                        {{ $t("averagePrice") }}:
                      </div>
                    </div>
                    <div class="w-100 text-right pr-md-2 pr-5">
                      <div class="float-right price-value" v-if="basePrice">
                        {{ getPriceValue() }}€
                      </div>
                      <div class="average-price float-right" style="text-decoration: line-through" v-if="
                        isGioielleriaItalianaB2B &&
                        retailPerc === 1 &&
                        currentJewelSelection.productType !== 'KIT' &&
                        getPriceValue() < getAverageOrVatPrice()
                      ">
                        {{ getAverageOrVatPrice() }}€
                      </div>
                    </div>
                  </div>
                  <div class="price-info delivery-label" v-if="currentJewelSelection.shipmentDate">
                    <div class="w-100 pl-md-2 pl-5">{{ $t("delivery") }}
                    </div>
                    <div class="w-100 text-right pr-md-2 pr-5">
                      {{
                        (logo || writing) && currentJewelSelection.engravingDate
                          ? currentJewelSelection.engravingDate
                          : currentJewelSelection.shipmentDate
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <textarea v-model="note" class="item-note" :placeholder="$t('note.placeholder')"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button id="basketbtn" class="btn text-uppercase rounded-btn w-100" :class="{
                    'btn-secondary': addedToBasket, 'btn-primary': !addedToBasket, 'ama': isAma}" 
                    :disabled="!jewelDescription ||
                    addedToBasket ||
                    !quantity ||
                    quantity === '0'
                    " v-on:click="addToBasketProduct">
                    <span class v-if="addedToBasket">{{
                      $t("addedToBasket")
                    }}</span>
                    <span class v-else>{{ $t("addToBasket") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 order-1 order-md-2">
          <div class="d-md-none text-left">
            <p class="font-weight-bold w-100 jewel-name title-font">
              {{ currentJewelSelection.name }}
            </p>
            <p class="text-break w-100  mb-0" v-if="currentJewelSelection.productType === 'KIT'">
              {{ $t(`kit-contains`) }}
            </p>
            <p class="text-break w-100 jewel-description" style="white-space: pre-line" v-html="jewelDescription"></p>
            <div class="mb-3" v-if="currentJewelSelection.productType === 'KIT'">
              <div class="wrapper">
                <table class="table table-image mb-0">
                  <thead>
                    <tr>
                      <th class="align-middle bl-color">{{ $t(`model`) }}</th>
                      <th class="align-middle bl-color">
                        {{ $t(`quantity`) }}
                      </th>
                      <th class="align-middle bl-color">
                        {{ $t(`description`) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in currentJewelSelection.itemsInKit" :key="index">
                      <td class="align-middle d-inline-flex w-100" :style="{
                        'border-top': index === 0 ? 'none !important' : '',
                      }" style="border-top: none !important">
                        <div style="align-self: center">
                          <span>{{ item.name || item.label }}</span>
                        </div>
                        <img style="align-self: center" height="50" width="50" :src="baseImageUrl + item.image"
                          alt="" />
                      </td>
                      <td class="align-middle bl-color">
                        <span> {{ item.quantity }} </span>
                      </td>
                      <td class="align-middle bl-color">
                        <span> {{ item.description }} </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <p class="text-left text-muted mb-1" v-if="selectedSku">
            SKU
            {{
              selectedSku
                ? selectedSku + additionalSkuLabelArray.join("")
                : null
            }}
          </p>
          <div class="
              text-center
              w-100
              mb-3
              position-relative
              border-img-container
            " v-if="jewelDescription">
            <img v-if="currentJewelSelection.productType === 'KIT'"
              :src="baseImageUrl + currentJewelSelection.images[0]" class="border-img-current w-100" />
            <img :src="baseImageUrl + imagesAvailable[0]" class="border-img-current w-100" v-if="
              currentJewelSelection.productType !== 'KIT' &&
              imagesAvailable &&
              imagesAvailable.length > 0 &&
              jewelDescription
            " />
          </div>
          <div v-if="
            imagesAvailable && imagesAvailable.length > 1 && jewelDescription
          ">
            <div v-swiper:mySwiper="swiperOptions" class="px-1 pt-2">
              <div class="swiper-wrapper">
                <div class="swiper-slide" :key="image" v-for="image in imagesAvailable">
                  <img :src="baseImageUrl + image" class="border-img w-100 mb-3" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 order-3 mt-3">
          <related-jewels></related-jewels>
        </div>
      </div>
    </div>
    <div class="col d-inline-flex px-0 mt-4 row" v-if="
      isSearching || (currentJewelSelection && !currentJewelSelection.name)
    ">
      <div class="col-12 mb-3 text-center justify-content-center mt-5">
        <DoubleBounce background="#00274F" size="100px"></DoubleBounce>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import ProductSettings from "./ProductSettings";
import RelatedJewels from "./RelatedJewels";
import Breadcrumb from "./Breadcrumb";
import { directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { DoubleBounce } from "vue-loading-spinner";
import Vue from "vue";

export default {
  name: "ProductDetail",
  components: {
    ProductSettings,
    RelatedJewels,
    DoubleBounce,
    Breadcrumb
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      imgError: ' "../assets/slider-1.png";',
      quantity: 1,
      imgaError: false,
      retailPerc: 1,
      vat: 1,
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
      note: null,
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // Some Swiper option/callback...
      },
    };
  },
  mounted() {
    this.getCategories();
    this.resetAdditionalSkuLabelArray();
  },
  created() {
    this.retailPerc = this.$store.state.productDetail.retailPerc;
    this.vat = this.$store.state.productDetail.vat;
    this.getValueForDetail();
    window.addEventListener("resize", Vue.setHeight);
  },
  destroyed() {
    this.resetCurrentCategory();
    this.resetCurrentJewel();
    window.removeEventListener("resize", this.myEventHandler);
  },
  watch: {
    "$route.params.sku": function (sku) {
      this.getValueForDetail();
    },
  },
  computed: mapState({
    currentCategory: (state) => state.productDetail.currentCategory,
    currentJewelSelection: (state) => state.productDetail.currentJewelSelection,
    origin: (state) => state.productDetail.origin,

    searchJewel: (state) => state.list.searchJewel,
    selectedSku: (state) => state.productDetail.selectedSku,
    additionalSkuLabelArray: (state) =>
      state.productDetail.additionalSkuLabelArray,
    imagesAvailable: (state) => state.productDetail.imagesAvailable,
    additionalValues: (state) => state.productDetail.additionalValues,
    preselectedJewel: (state) => state.productDetail.preselectedJewel,
    isSearching: (state) => state.productDetail.isSearching,
    basePrice: (state) => state.productDetail.basePrice,
    avgPrice: (state) => state.productDetail.avgPrice,
    logo: (state) => state.productDetail.logo,
    writing: (state) => state.productDetail.writing,
    selectedProduct: (state) => state.productDetail.selectedProduct,
    jewelDescription: (state) => state.productDetail.jewelDescription,
    selectedStyle: (state) => state.list.style,
    addedToBasket: (state) => state.productDetail.addedToBasket,
    isGioielleriaItalianaB2B: (state) => state.config.isGioielleriaItalianaB2B,
    isAma: (state) => state.config.isAma,
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  }),
  methods: {
    ...mapMutations("productDetail", [
      "setValueAndChange",
      "addValuesToSelected",
      "addValueToJewel",
      "setQuantityProduct",
      "setAddedToBasket",
      "resetAdditionalSkuLabelArray",
      "resetCurrentCategory",
      "resetCurrentJewel"
    ]),
    ...mapMutations("list", ["setStyle", "setJewelSearch"]),
    ...mapMutations("productDetail", ["setPreselectedProduct"]),
    ...mapActions("productDetail", [
      "getValues",
      "getListCategories",
      "getValuesForKit",
      "resetDetail",
    ]),
    getCategories() {
      this.getListCategories("categories");
    },
    getPriceValue() {
      if (this.basePrice) {
        return parseFloat(
          (
            (this.basePrice + this.additionalValues) *
            this.vat *
            this.quantity *
            this.retailPerc
          ).toFixed(2)
        ).toLocaleString("it-it");
      } else {
        return "";
      }
    },
    getAverageOrVatPrice() {
      if (this.vat > 1) {
        return parseFloat(
          (
            this.basePrice * this.vat * this.quantity +
            this.additionalValues
          ).toFixed(2)
        ).toLocaleString("it-it");
      } else {
        if (this.avgPrice) {
          return parseFloat(
            (this.avgPrice * this.quantity + this.additionalValues).toFixed(2)
          ).toLocaleString("it-it");
        } else {
          return "";
        }
      }
    },
    onImageLoadFailure() {
      this.imgaError = true;
    },

    // function used to change values in each field
    triggerToChange(value) {
      this.setValueAndChange(value);
    },

    changeQuantity() {
      this.quantity = parseInt(this.quantity);
      this.setQuantityProduct(parseInt(this.quantity));
    },

    setBaseQuantity(qnt) {
      this.quantity = parseInt(qnt);
    },
    scrollTo(height) {
      window.parent.postMessage(
        {
          func: "setGioielleriaItalianaScroll",
          message: height,
        },
        "*"
      );
    },
    getValueForDetail() {
      if (this.$route.params.kit && this.$route.params.kit != 'false') {
        this.getValuesForKit(this.$route.params.sku);
      } else {
        this.getValues(this.$route.params.sku);
      }
      this.quantity = parseInt(this.$store.state.productDetail.quantity);
    },

    addToBasketProduct() {
      this.addValuesToSelected({ qnt: parseInt(this.quantity), note: this.note });
      this.$parent.addToBasketProduct();
      this.setAddedToBasket(true);
    },

    back() {
      this.setPreselectedProduct({});
      this.setQuantityProduct(1);

      this.$router.push({
        name: "product.list",
        params: {
          typeId: this.currentJewelSelection.productType,
        },
      });
    },

    backHome() {
      const root = document.documentElement;
      this.setStyle("gioielleria");
      // if (
      //   this.origin.startsWith("https://shop-test.gioielleriaitaliana.com") ||
      //   this.origin.startsWith("https://shop.gioielleriaitaliana.com")
      // ) {
      //   window.parent.location.href = this.origin;
      // } else {
      this.setQuantityProduct(1);

      this.$router.push({ name: "list" });
      // }
    },
    resetFilters() {
      this.setJewelSearch({
        label: "goldColorId",
        value: null,
      });
      this.setJewelSearch({
        label: "stoneColor",
        value: null,
      });
      this.stoneTypeSelectedId = null;
      this.setJewelSearch({
        label: "category",
        value: null,
      });
      this.setJewelSearch({
        label: "subCategory",
        value: null,
      });
      this.subCategorySelectedId = null;
      this.setJewelSearch({
        label: "minPrice",
        value: null,
      });
      this.setJewelSearch({
        label: "maxPrice",
        value: null,
      });
      this.setJewelSearch({
        label: "text",
        value: null,
      });
      this.setJewelSearch({
        label: "sku",
        value: null,
      });
    },

    goTo(type) {
      this.setStyle(type);
      const root = document.documentElement;
      this.setPreselectedProduct({});
      this.resetFilters();

      this.$router.push({
        name: "product.list",
        params: {
          typeId: this.currentJewelSelection.categoryId,
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.border-img {
  box-shadow: 0px 2px 5px 0px #707070;
}

.choice-list {
  font-size: 20px;
}

.border-img-container {
  position: relative;
  width: 100%;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0px 2px 5px 0px #707070;
}

.border-img-current {
  width: 100%;
  // min-height: 570px;
  object-fit: cover;
  // -moz-transform: scale(1.8);
  // -webkit-transform: scale(1.8);
  // transform: scale(1.8);
  max-width: 100%;
}

#basketbtn.btn-primary {
  border-radius: 5px;
  background-color: var(--primary-color-1);
  color: #fff !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  font-size: 16px;
}


#basketbtn.btn-secondary {
  border-radius: 5px;
  color: #fff !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  font-size: 16px;
}

#basketbtn.btn-primary.ama,#basketbtn.btn-secondary.ama {
  background-color: var(--ama-green);
  color: var(--ama-white);
  font-family: var(--font-family-reckless-italic);
  width: 100%;
  margin-top: 5px;
  cursor: pointer;
}

div.rounded-side {
  border-radius: 0 100em 100em 0;
  box-shadow: 0px 1px 4px 0px #707070;
  // height: 40px;
  // line-height: 40px;
}

.average-price {
  font-size: 10px;
  width: 100%;
}

@media only screen and (min-width: 768px) {
  .opt-top {
    margin-top: -200px;
  }

  .average-price {
    font-size: 12px;
    width: 100%;
  }
}

.bg-or {
  background-color: var(--primary-color-1) !important;
  color: var(--fixed-primary-color-1);
  // width: 20%;
  cursor: pointer;
}

.bg-gi {
  background-color: var(--fixed-primary-color-1);
  color: #fff;

  // width: 20%;
  cursor: pointer;
}

.bg-no-sel {
  background-color: var(--non-selected-color-bg-1);
  color: var(--non-selected-color-label-1);
  // width: 15%;
  cursor: pointer;
}

.description-title {
  color: var(--gray-label-1);
  font-size: 14px;
}

.path-list {
  font-family: var(--font-family);
  font-size: 20px;
  color: var(--secondary-color-1);
}

.title-font {
  font-family: var(--secondary-font-family);
  font-size: 18px;
  font-weight: 500;
}

.input-quantity {
  border: 1px solid var(--primary-color-1);
  border-radius: 7px;
  line-height: 25px;
  width: inherit;
}

.delivery-label {
  font-weight: 300;
  font-size: 12px;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-top: 1px solid var(--secondary-color-1);
  margin: 10px 0px;
}

.price-value {
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-family: var(--secondary-font-family);
  font-size: 20px;
  font-weight: 500;
  width: 100%;
  line-height: 22px;
}

.avg-price-label {
  font-weight: 500;
  line-height: 22px;
}

.label-menu {
  font-size: 18px;
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .label-menu {
    font-size: 12px;
  }

  .rounded-btn {
    font-size: 12px;
  }

  .choice-list {
    font-size: 16px;
  }

  .jewel-name,
  .jewel-description {
    font-size: 12px !important;
  }
}

@media only screen and (max-width: 768px) {

  .jewel-name,
  .jewel-description {
    margin-left: 0px !important;
  }

  .rounded-btn {
    font-size: 12px;
  }

  .price-value {
    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    font-family: var(--secondary-font-family);
    font-size: 14px;
    font-weight: 500;
    width: 100%;
  }

  .label-menu {
    font-size: 12px;
  }

  .rounded-btn {
    font-size: 12px;
  }

  .choice-list {
    font-size: 16px;
  }
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.optional-img {
  -moz-transform: scale(0.6);
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}

table {
  border-collapse: collapse !important;
  border-spacing: 0;
  border-style: hidden;
}

.wrapper {
  overflow: auto;
  border-radius: 15px;
  border: 1px solid var(--primary-color-1);
}

tr tr:first-child td {
  border-top: none !important;
}

th,
td {
  border-top: 1px solid var(--primary-color-1) !important;

  // border-left: 1px solid var(--primary-color-1) !important;
  span {
    font-size: 14px;
  }
}

.bl-color {
  border-left: 1px solid var(--primary-color-1) !important;
}

.jewel-name {
  font-size: 18px;
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: 1px solid var(--secondary-color-1);
  padding-bottom: 3px;
  margin-bottom: 10px;
}

.jewel-description {
  color: var(--gray-label-1);
  font-size: 14px;
  padding-top: 10px;
}

div.price-info {
  border-bottom: 1px solid var(--secondary-color-1);
  padding: 5px 0px;
  display: flex;

  .label-menu {
    width: 100%;
  }
}

.jewel-value {
  border: 1px solid var(--primary-color-1) !important;
  margin-top: 10px;
}

.margin-top-auto {
  margin-top: auto;
}

.item-note {
  width: 100%;
  font-size: 14px;
  padding: 4px;
}
</style>
